import {
  FormControl,
  FormControlProps,
  FormLabel,
  Radio,
} from "@chakra-ui/react";
import React from "react";
import useInProgressDisable from "../../hooks/useInProgressDisable";

export type RadioFieldProps = {
  label?: string;
  name: string;
  errorText?: string;
  isChecked?: boolean;
  value?: number;
  onChange?: (e: any) => void;
  disabled?: boolean;
  radioProps?: FormControlProps;
};

function RadioField(props: RadioFieldProps) {
  const { name, isChecked, onChange, label, radioProps, disabled, value } =
    props;

  return (
    <FormControl display="flex" justifyContent="center" {...radioProps}>
      <FormLabel fontSize="md" htmlFor={name} mb="0">
        {label}
      </FormLabel>
      <Radio
        isDisabled={useInProgressDisable(name) || disabled}
        isChecked={isChecked}
        value={value}
        onChange={onChange}
        name={name}
      ></Radio>
    </FormControl>
  );
}

export default RadioField;
